const SELECTORS = {
  ITEM_OPEN: "faq__item--open",
  ITEM_LABEL: ".faq__item-label",
};

export function isFaqItemOpen(item) {
  return item.classList.contains(SELECTORS.ITEM_OPEN);
}

/**
 * Открывает или закрывает пункт FAQ.
 * Состояние хранится в классе (для CSS) и в aria-expanded (для скринридеров).
 */
export function setFaqItemOpen(item, open) {
  item.classList.toggle(SELECTORS.ITEM_OPEN, open);
  item
    .querySelector(SELECTORS.ITEM_LABEL)
    ?.setAttribute("aria-expanded", String(open));
}
